import { delegate } from 'jquery-events-to-dom-events'

delegate('hidden.bs.dropdown')
